// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-main {\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n}\r\n.admin-paper {\r\n  width: 50%;\r\n  height: calc(100vh - 70px);\r\n  overflow: auto;\r\n  margin-top: 10px;\r\n  padding: 20px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
